/* eslint-disable no-throw-literal */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import clubAPI from "../api/clubAPI";
import "../App.scss";
import swalDialog from "../helpers/swalErrorPopup";
import FreeFitDefaultImg from "../img/freefit_default.png";
import HistoryDefImg from "../img/history_def_img.png";
import dropdownIcon from "../img/svg/dropdown_icon.svg";
import navIcon from "../img/svg/navigation_icon.svg";
import CustomSearch from "../shared/CustomSearch";
import Dropdown from "../shared/Dropdown";
import ImageWithFallback from "../shared/imageWithFallback";
import { PoweredBy } from "../shared/PoweredBy";
import { updateAllAppParams, updateAllClubParams } from "../store/appParamSlice";
import { footerCustomDisplaying, headerCustomDisplaying, isLoadChanger, setCustomHeaderText } from "../store/mainSlice";
import { isPartnerClalit, selectIsOrthodox } from "../store/partnerStore";

function FitExtendSelector() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isClalit = useSelector(isPartnerClalit);
  const isOrthodox = useSelector(selectIsOrthodox);
  const [detailedClubParams, setDetailedClubParams] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCityObject, setSelectedCityObject] = useState();
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedClubCategory, setSelectedClubCategory] = useState("");

  const userParams = useSelector((state) => state.userSlice.userData);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);
  const clubCategories = useSelector((state) => state.appParamSlice.clubCategories);
  const navigate = useNavigate();

  const [allClubs, setAllClubs] = useState([]);

  useEffect(() => {
    if (Object.keys(cityAndClubs).length > 0) {
      setAllClubs(cityAndClubs.ClubList);
    }
  }, [cityAndClubs]);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getWebFullData({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (param.data.Error !== 0) {
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }

        dispatch(updateAllAppParams(JSON.parse(param.data.Data)));
        const clubResp = await clubAPI.getClubCategoryList({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
          isFreefitWeb: true,
        });
        if (clubResp.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: clubResp.data.Error,
            mess: clubResp.data.Message,
          };
        }
        const clubParam = JSON.parse(param.data.Data);
        dispatch(updateAllClubParams(JSON.parse(clubResp.data.Data)));
        setDetailedClubParams(clubParam?.ClubList);

        dispatch(isLoadChanger(false));
      } catch (err) {
        swalDialog(err);
      }
    };
    if (userParams && Object.keys(userParams).length > 0) {
      if (isClalit) {
        fetch();
      } else if (clubCategories.length === 0 || Object.keys(cityAndClubs).length === 0) {
        fetch();
      }
    }
  }, [userParams]);

  useEffect(() => {
    const fetch = async () => {
      let clubs = cityAndClubs?.ClubList;
      if (selectedCity) {
        clubs = clubs.filter((el) => el.AreaName.includes(selectedCity));
      }
      if (selectedClub) {
        clubs = clubs.filter((el) => el.RecordID == selectedClub);
      }
      if (selectedClubCategory) {
        try {
          dispatch(isLoadChanger(true));
          const payload = {
            binID: userParams.BinID,
            mainCatID: selectedClubCategory.value,
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          };
          if (!isClalit) {
            payload.cityId = selectedCityObject.value;
            payload.isFreefitWeb = true;
          }
          let clubsInCategory = await clubAPI.getClubsByCategory(payload);
          const allowedClubs = JSON.parse(clubsInCategory.data.Data).ClubsList;
          clubs = clubs.filter((el) => allowedClubs.includes(el.RecordID));
          dispatch(isLoadChanger(false));
        } catch (err) {
          dispatch(isLoadChanger(false));
          swalDialog(err);
        }
      }
      setDetailedClubParams(clubs);
      setAllClubs(clubs);
    };
    fetch();
  }, [selectedCity, selectedClub, selectedClubCategory]);

  useEffect(() => {
    dispatch(headerCustomDisplaying(true));
    dispatch(footerCustomDisplaying(true));
    dispatch(setCustomHeaderText(t("COMPLETE_CLUB_LIST")));
    return () => {
      dispatch(headerCustomDisplaying(false));
      dispatch(footerCustomDisplaying(false));
      dispatch(setCustomHeaderText(""));
    };
  }, [t]);

  const handleSelectCity = async (selectedOption) => {
    setSelectedCity(selectedOption?.label);
    setSelectedCityObject(selectedOption);
    if (!isClalit) {
      const param = await clubAPI.getClubsByCategoryByCityId({
        binID: userParams.BinID,
        id: mainUserParams.ID,
        token: mainUserParams.Token,
        phone: mainUserParams.Phone,
        cityId: selectedOption.value,
      });
      if (param.data.Error !== 0) {
        throw {
          code: param.data.Error,
          mess: param.data.Message,
        };
      }
      const cityCategories = JSON.parse(param.data.Data);
      dispatch(updateAllClubParams(cityCategories));
    }
  };

  const handleSelectClub = (selectedOption) => {
    setSelectedClub(selectedOption?.value);
  };

  const handleSelectClubCategory = (selectedOption) => {
    setSelectedClubCategory(selectedOption);
  };

  const handleSearch = () => {};

  return (
    <div className="main-page-container">
      {isClalit ? (
        <div className="fit-extend-selector-dropdowns-container">
          <Dropdown
            options={
              cityAndClubs?.CityList && Array.isArray(cityAndClubs?.CityList) && cityAndClubs?.CityList.length > 0
                ? cityAndClubs?.CityList.map((el) => ({
                    value: el.RecordID,
                    label: el.Name,
                  }))
                : []
            }
            onSelect={handleSelectCity}
            imgUrl={navIcon}
            placeholder={t("SELECT_SEARCH_CITY")}
          />
          <Dropdown
            options={
              allClubs && Array.isArray(allClubs) && allClubs.length > 0
                ? allClubs?.map((el) => ({
                    value: el.RecordID,
                    label: el.Name,
                  }))
                : []
            }
            onSelect={handleSelectClub}
            imgUrl={dropdownIcon}
            isShouldRotate={true}
            placeholder={t("SELECT_SEARCH_CLUB")}
          />
          <Dropdown
            options={
              clubCategories && Array.isArray(clubCategories) && clubCategories.length > 0
                ? clubCategories.map((el) => ({
                    value: el.ID,
                    label: el.Name,
                  }))
                : []
            }
            onSelect={handleSelectClubCategory}
            imgUrl={dropdownIcon}
            isShouldRotate={true}
            placeholder={t("SEARCH_BY_CATEGORY")}
          />
        </div>
      ) : (
        <CustomSearch
          cityOptions={
            cityAndClubs?.CityList && Array.isArray(cityAndClubs?.CityList) && cityAndClubs?.CityList.length > 0
              ? cityAndClubs?.CityList.map((el) => ({
                  value: el.RecordID,
                  label: el.Name,
                }))
              : []
          }
          clubOptions={
            allClubs && Array.isArray(allClubs) && allClubs.length > 0
              ? allClubs?.map((el) => ({
                  value: el.RecordID,
                  label: el.Name,
                }))
              : []
          }
          categoryOptions={
            clubCategories && Array.isArray(clubCategories) && clubCategories.length > 0
              ? clubCategories.map((el) => ({
                  value: el.ID,
                  label: el.Name,
                }))
              : []
          }
          onCitySelect={handleSelectCity}
          onClubSelect={handleSelectClub}
          onCategorySelect={handleSelectClubCategory}
        />
      )}

      <div className="fit-extend-selector-elements-container">
        {detailedClubParams && Array.isArray(detailedClubParams) && detailedClubParams.length > 0
          ? detailedClubParams.map((el, i) => (
              <div
                className="fit-extend-selector-card"
                key={i}
                onClick={(e) => {
                  navigate(`/venue/${el.RecordID}`, {
                    state: {
                      price: el.Price,
                      clubId: el.RecordID,
                      clubName: el.Name,
                    },
                  });
                }}
              >
                <div className="fit-extend-selector-content-wrapper">
                  <div className="fit-extend-selector-left">
                    {el.Price > 0 ? (
                      <p className="fit-extend-selector-price"> ₪{el.Price}</p>
                    ) : (
                      <p className="fit-extend-selector-price"> </p>
                    )}
                    <button className="select-room-by-date-main-element-btn-coloured">{t("TO_BOOK")}</button>
                  </div>

                  <div className="fit-extend-selector-content-body">
                    <div className="fit-extend-selector-content-adress-and-name">
                      <p className="fit-extend-selector-content-header-text">{el.Name}</p>
                      <p className="fit-extend-selector-content-body-first">{el.Address}</p>
                    </div>
                  </div>
                </div>
                <div className="select-room-by-date-club-img-wrapper">
                  <ImageWithFallback
                    src={isOrthodox ? FreeFitDefaultImg : el.MobClubLogoPath}
                    fallbackSrc={isClalit ? HistoryDefImg : FreeFitDefaultImg}
                    alt="Club logo"
                  />
                </div>
              </div>
            ))
          : ""}
      </div>

      {isClalit && (
        <div style={{ position: "sticky", bottom: 0 }}>
          <PoweredBy />
        </div>
      )}
    </div>
  );
}

export default FitExtendSelector;
